import {
  identifierSerializerSeriesIdDataIndex,
  identifierCleanerSeriesIdDataIndex,
  createIsHighlighted,
  createIsFaded,
  polarSeriesTypes,
} from '@mui/x-charts/internals';
import type { ChartSeriesTypeConfig } from '@mui/x-charts/internals';
import legendGetter from './legend';
import { selectorTooltipItemPosition } from './tooltipPosition';
import keyboardFocusHandler from './keyboardFocusHandler';
import { axisTooltipGetter } from './axisTooltipGetter';
import colorProcessor from './getColor';
import seriesProcessor from './seriesProcessor';
import getSeriesWithDefaultValues from './getSeriesWithDefaultValues';
import descriptionGetter from './descriptionGetter';
import getItemAtPosition from './getItemAtPosition';
import { radiusExtremumGetter, rotationExtremumGetter } from './extremums';
import tooltipGetter from './tooltip';

polarSeriesTypes.addType('radialBar');

export const radialBarSeriesConfig: ChartSeriesTypeConfig<'radialBar'> = {
  colorProcessor,
  seriesProcessor,
  legendGetter,
  tooltipGetter,
  selectorTooltipItemPosition,
  axisTooltipGetter,
  rotationExtremumGetter,
  radiusExtremumGetter,
  getSeriesWithDefaultValues,
  getItemAtPosition,
  keyboardFocusHandler,
  identifierSerializer: identifierSerializerSeriesIdDataIndex,
  identifierCleaner: identifierCleanerSeriesIdDataIndex,
  descriptionGetter,
  isHighlightedCreator: createIsHighlighted,
  isFadedCreator: createIsFaded,
};
